<template>
  <div style="width: 100%; height: 100%; min-width: 1280px; padding: 10px;">
    <div style="display: flex; flex-direction: column; flex: 1; height: 100%; min-width: 1280px;">
      <ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick"
        :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings"
        :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true"
        :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true'
        :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" :childGrid="childGrid" :detailDataBound='onDetailDataBound'>
        <e-columns>
          <e-column field="date" :headerText="$t('Date')" textAlign="Left" :customAttributes="customAttributes" type="date" :format="dateTimeFormatOptions"></e-column>
          <e-column field="logsCount" :headerText="$t('Logs')" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="weightLogsCount" :headerText="$t('WeightLogsCount')" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="unknownWeightLogsCount" :headerText="$t('UnknownAnimalWeightLogsCount')" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="errorLogsChecked" :headerText="$t('ErrorLogsChecked')" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="weightErrorLogsChecked" :headerText="$t('WeightErrorLogsChecked')" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="otherReasonLogsCount" :headerText="$t('OtherReasonLogs')"  :template="LogReasonTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="ghostAnimalsCount" :headerText="$t('GhostAnimals')" textAlign="Left" :customAttributes="customAttributes"></e-column>
          <e-column field="unknownAnimalsCount" :headerText="$t('UnknownAnimals')" textAlign="Left" :customAttributes="customAttributes"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { getStatisticsForSystem } from '@api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport, DetailRow } from '@syncfusion/ej2-vue-grids';
import LogReasonTooltip from "@/components/Settings/LogReasonTooltip.vue";
import { getDeviceStatisticsForSystem } from '../../api/api';
import LoadcellTooltipCellVue from '../../components/Settings/LoadcellTooltipCell.vue';

export default {
  props: ['systemId', 'systemName'],
  provide: {
    grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport, DetailRow]
  },
  components: {
    LogReasonTooltip
  },
  data() {
    return {
      data: [],
      pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
      toolbar: [
        { text: this.$i18n.t('Statistics'), id: 'table-settings-title'},
        { text: this.$i18n.t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right', },
        { text: this.$i18n.t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' },
        { text: this.$i18n.t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' },
        { text: this.$i18n.t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' },
        'Search',
      ],
      childGrid: {
          queryString: "date",
          allowSorting: true,
          columns: [
              { field: "unitNumber", headerText: this.$i18n.t('Device'), textAlign: "Left" },
              { field: "TodayResult", headerText: this.$i18n.t('TodayResult'), textAlign: "Left", allowSorting: false  },
              { field: "WeekResult", headerText: this.$i18n.t('WeekResult'), textAlign: "Left", allowSorting: false, },
              { field: "CorrectPercent", headerText: this.$i18n.t('CorrectPercent'), textAlign: "Left" },
              { field: "SyncTodayResult", headerText: this.$i18n.t('SyncTodayResult'), textAlign: "Left", allowSorting: false  },
              { field: "DlcRightErrorLogsCountResult", headerText: this.$i18n.t('DlcRight'), textAlign: "Left"  },
              { field: "DlcLeftErrorLogsCountResult", headerText: this.$i18n.t('DlcLeft'), textAlign: "Left"  },
              { field: "UnderMinOpenLevelTimeResult", headerText: this.$i18n.t('UnderMinOpenLevelTime'), textAlign: "Left", sortComparer: this.timeFormatSortComparer },
              { field: "UnderAlarmLevelTimeResult", headerText: this.$i18n.t('UnderAlarmLevelTime'), textAlign: "Left", sortComparer: this.timeFormatSortComparer },
              { field: "NoRapidLogTimeResult", headerText: this.$i18n.t('NoRapidLogTime'), textAlign: "Left", sortComparer: this.timeFormatSortComparer },
              { field: "LoadCellErrorCodeResult", headerText: this.$i18n.t('LoadcellError'), textAlign: "Left", template: function () {
                      return {
                          template: {
                              extends: LoadcellTooltipCellVue,
                          },
                      };
                  },
              },
          ],
      },
      wrapSettings: { wrapMode: "Content" },
      selectionOptions: { type: "Multiple" },
      filterOptions: {
        type: "Menu",
      },
      customAttributes: { class: 'customcss' },
      sortingModes: [],
      dateTimeFormatOptions: { format: 'yyyy-MM-dd', type: 'date' },
      LogReasonTemplate: function () {
        return {
          template: {
            extends: LogReasonTooltip
          }
        }
      },
    }
  },
  methods: {
    async getData() {
      this.data = [];
      this.$emit('spin', true)

      var statistics7Days = await getStatisticsForSystem(this.systemId);

      statistics7Days.forEach((s) => {
        s.errorLogsChecked = s.errorLogsCount + " / " + s.checkedLogsCount;
        s.weightErrorLogsChecked = s.weightErrorLogsCount + " / " + s.checkedWeightLogsCount;
      })

      this.data = statistics7Days;
      this.$emit('spin', false)
    },
    timeFormatSortComparer(ref, comp) {
        var r = this.valueFromTime(ref)
        var c = this.valueFromTime(comp)
        if(r < c) {
            return -1;
        } else if (r > c) {
            return 1;
        }
        return 0;
    },
    valueFromTime(el) {
        if (el == '-'){
            return 0;
        } else if(el.includes('s')) {
            refValue = el.replace('s', '')
            return parseInt(refValue)
        } else {
            var refSplit = el.replace('h', '').replace('min', '').split(' ')
            var r = (refSplit[0] * 60 + refSplit[1]) * 60
            return r
        }
    },
    toolbarClick: function (args) {
      switch (args.item.id) {
        case "table-system-title":
          this.$router.push({
            name: "systems"
          })
          break;
        case "table-settings-title":
          this.getData();
          break;
        case "pdf-export":
          this.$refs.grid.pdfExport();
          break;
        case "csv-export":
          this.$refs.grid.csvExport();
          break;
        case "excel-export":
          this.$refs.grid.excelExport();
          break;
        case 'clear-filters':
          this.$refs.grid.clearFiltering();
          break;
      }
    },
    dataBound: function () {
      this.$refs.grid.autoFitColumns();
    },
    onDetailDataBound(args) {
      getDeviceStatisticsForSystem(this.systemId, args.data.date).then(response => {
        let dailyDeviceStatistics = response.data;

        dailyDeviceStatistics.forEach(d => {
          let correct = d.correctLogs + d.correctLogsWeekBefore
          let total = d.totalLogs + d.totalLogsWeekBefore
          let synccorrect = d.correctSyncLogs;
          let synctotallogs = d.totalSyncLogs;
          d.TodayResult = `${d.correctLogs}/${d.totalLogs}`
          d.SyncTodayResult = `${d.correctSyncLogs}/${d.totalSyncLogs}`
          d.WeekResult = `${correct}/${total}`
          if(total){
            d.CorrectPercent = ((correct / total) * 100).toFixed(2) + "%"
          } else {
            d.CorrectPercent = '-'
          }

          if( d.dlcRightErrorLogsCountWeekBefore == 0) {
            d.DlcRightErrorLogsCountResult = "-"
          } else {
            d.DlcRightErrorLogsCountResult = `${((d.dlcRightErrorLogsCount / d.dlcRightErrorLogsCountWeekBefore) * 100).toFixed(2)}%`
          }

          if(d.dlcLeftErrorLogsCountWeekBefore == 0) {
            d.DlcLeftErrorLogsCountResult = '-'
          } else {
            d.DlcLeftErrorLogsCountResult = `${((d.dlcLeftErrorLogsCount / d.dlcLeftErrorLogsCountWeekBefore) * 100).toFixed(2)}`
          }
          d.UnderMinOpenLevelTimeResult = `${d.underMinOpenLevelTime.toAgoString()}`
          d.UnderAlarmLevelTimeResult = `${d.underAlarmLevelTime.toAgoString()}`
          d.NoRapidLogTimeResult = `${d.noRapidLogTime.toAgoString()}`
          d.LoadCellErrorCodeResult = `${d.loadCellErrorCode == 0 ? '-' : d.loadCellErrorCode}`
        });

        dailyDeviceStatistics.sort((a, b) => a.unitNumber - b.unitNumber)

        args.detailElement.querySelector(
          ".e-grid"
        ).ej2_instances[0].dataSource = dailyDeviceStatistics;
      })
    }
  },
  mounted: async function () {
    await this.getData();
  },
}
</script>

<style>
.tippy-tooltip.customTheme-theme {
  background-color: #346F8B;
}

.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
  border-left: 8px solid #346F8B;
}
</style>



// WEBPACK FOOTER //
// src/views/System/SettingsStatistics.vue